import { Union, Record } from "./fable_modules/fable-library.3.7.20/Types.js";
import { bool_type, union_type, list_type, option_type, record_type, class_type, string_type, int32_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { ClientConfig$reflection } from "./Global.js";
import { IsoCountryCode$reflection } from "./DomainTypes.js";

export class Numbers extends Record {
    constructor(ContractNr, Icc, Imsi, Number$) {
        super();
        this.ContractNr = (ContractNr | 0);
        this.Icc = Icc;
        this.Imsi = Imsi;
        this.Number = Number$;
    }
}

export function Numbers$reflection() {
    return record_type("CommonTypes.Numbers", [], Numbers, () => [["ContractNr", int32_type], ["Icc", string_type], ["Imsi", class_type("System.Int64")], ["Number", string_type]]);
}

export class SearchResult extends Record {
    constructor(CurrentState, InvoiceeNr, Name, Email, Numbers, OrganizationNr) {
        super();
        this.CurrentState = CurrentState;
        this.InvoiceeNr = InvoiceeNr;
        this.Name = Name;
        this.Email = Email;
        this.Numbers = Numbers;
        this.OrganizationNr = OrganizationNr;
    }
}

export function SearchResult$reflection() {
    return record_type("CommonTypes.SearchResult", [], SearchResult, () => [["CurrentState", option_type(string_type)], ["InvoiceeNr", class_type("System.Int64")], ["Name", string_type], ["Email", string_type], ["Numbers", list_type(Numbers$reflection())], ["OrganizationNr", string_type]]);
}

export class SearchResultV2 extends Record {
    constructor(SearchResult, TotalCount) {
        super();
        this.SearchResult = SearchResult;
        this.TotalCount = (TotalCount | 0);
    }
}

export function SearchResultV2$reflection() {
    return record_type("CommonTypes.SearchResultV2", [], SearchResultV2, () => [["SearchResult", list_type(SearchResult$reflection())], ["TotalCount", int32_type]]);
}

export class SubItem extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["FablePage", "IFramePage", "ExternalUrlPage"];
    }
}

export function SubItem$reflection() {
    return union_type("CommonTypes.SubItem", [], SubItem, () => [[["Item", MenuItem$reflection()]], [["Item", MenuItem$reflection()]], [["Item", MenuItem$reflection()]]]);
}

export class MenuItem extends Record {
    constructor(Title, Url, SubItems) {
        super();
        this.Title = Title;
        this.Url = Url;
        this.SubItems = SubItems;
    }
}

export function MenuItem$reflection() {
    return record_type("CommonTypes.MenuItem", [], MenuItem, () => [["Title", string_type], ["Url", option_type(string_type)], ["SubItems", list_type(SubItem$reflection())]]);
}

export class MenuItemTypeDTO extends Record {
    constructor(PageType, ExternalUrl) {
        super();
        this.PageType = PageType;
        this.ExternalUrl = ExternalUrl;
    }
}

export function MenuItemTypeDTO$reflection() {
    return record_type("CommonTypes.MenuItemTypeDTO", [], MenuItemTypeDTO, () => [["PageType", string_type], ["ExternalUrl", option_type(string_type)]]);
}

export class MenuItemDTO extends Record {
    constructor(Title, Url, MenuItemType, SubItems) {
        super();
        this.Title = Title;
        this.Url = Url;
        this.MenuItemType = MenuItemType;
        this.SubItems = SubItems;
    }
}

export function MenuItemDTO$reflection() {
    return record_type("CommonTypes.MenuItemDTO", [], MenuItemDTO, () => [["Title", string_type], ["Url", option_type(string_type)], ["MenuItemType", option_type(MenuItemTypeDTO$reflection())], ["SubItems", list_type(MenuItemDTO$reflection())]]);
}

export class AvailableLanguage extends Record {
    constructor(CSSLanguage, Language, Country, LanguageLong) {
        super();
        this.CSSLanguage = CSSLanguage;
        this.Language = Language;
        this.Country = Country;
        this.LanguageLong = LanguageLong;
    }
}

export function AvailableLanguage$reflection() {
    return record_type("CommonTypes.AvailableLanguage", [], AvailableLanguage, () => [["CSSLanguage", string_type], ["Language", string_type], ["Country", string_type], ["LanguageLong", string_type]]);
}

export class Role extends Record {
    constructor(ClientNr, InvoiceeNr, RoleName) {
        super();
        this.ClientNr = ClientNr;
        this.InvoiceeNr = InvoiceeNr;
        this.RoleName = RoleName;
    }
}

export function Role$reflection() {
    return record_type("CommonTypes.Role", [], Role, () => [["ClientNr", option_type(int32_type)], ["InvoiceeNr", option_type(int32_type)], ["RoleName", option_type(string_type)]]);
}

export class RoleItem extends Record {
    constructor(SelectableRoles, SelectedRole) {
        super();
        this.SelectableRoles = SelectableRoles;
        this.SelectedRole = SelectedRole;
    }
}

export function RoleItem$reflection() {
    return record_type("CommonTypes.RoleItem", [], RoleItem, () => [["SelectableRoles", list_type(Role$reflection())], ["SelectedRole", Role$reflection()]]);
}

export class SessionContextDTO extends Record {
    constructor(AccountType, AvailableLanguages, ClientConfig, CurrentUserName, RequireIdsStepUp, IsAdminUser, MenuItems, RoleItems, SelectedLanguage, VersionBadgeUrl, CountryCode, LanguageCode, Privileges) {
        super();
        this.AccountType = AccountType;
        this.AvailableLanguages = AvailableLanguages;
        this.ClientConfig = ClientConfig;
        this.CurrentUserName = CurrentUserName;
        this.RequireIdsStepUp = RequireIdsStepUp;
        this.IsAdminUser = IsAdminUser;
        this.MenuItems = MenuItems;
        this.RoleItems = RoleItems;
        this.SelectedLanguage = SelectedLanguage;
        this.VersionBadgeUrl = VersionBadgeUrl;
        this.CountryCode = CountryCode;
        this.LanguageCode = LanguageCode;
        this.Privileges = Privileges;
    }
}

export function SessionContextDTO$reflection() {
    return record_type("CommonTypes.SessionContextDTO", [], SessionContextDTO, () => [["AccountType", string_type], ["AvailableLanguages", list_type(AvailableLanguage$reflection())], ["ClientConfig", option_type(ClientConfig$reflection())], ["CurrentUserName", string_type], ["RequireIdsStepUp", bool_type], ["IsAdminUser", bool_type], ["MenuItems", list_type(MenuItemDTO$reflection())], ["RoleItems", RoleItem$reflection()], ["SelectedLanguage", string_type], ["VersionBadgeUrl", option_type(string_type)], ["CountryCode", IsoCountryCode$reflection()], ["LanguageCode", string_type], ["Privileges", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

export class SessionContext extends Record {
    constructor(AccountType, AvailableLanguages, ClientConfig, CurrentUserName, RequireIdsStepUp, IsAdminUser, MenuItems, RoleItems, SelectedLanguage, VersionBadgeUrl, CountryCode, LanguageCode, Privileges) {
        super();
        this.AccountType = AccountType;
        this.AvailableLanguages = AvailableLanguages;
        this.ClientConfig = ClientConfig;
        this.CurrentUserName = CurrentUserName;
        this.RequireIdsStepUp = RequireIdsStepUp;
        this.IsAdminUser = IsAdminUser;
        this.MenuItems = MenuItems;
        this.RoleItems = RoleItems;
        this.SelectedLanguage = SelectedLanguage;
        this.VersionBadgeUrl = VersionBadgeUrl;
        this.CountryCode = CountryCode;
        this.LanguageCode = LanguageCode;
        this.Privileges = Privileges;
    }
}

export function SessionContext$reflection() {
    return record_type("CommonTypes.SessionContext", [], SessionContext, () => [["AccountType", string_type], ["AvailableLanguages", list_type(AvailableLanguage$reflection())], ["ClientConfig", option_type(ClientConfig$reflection())], ["CurrentUserName", string_type], ["RequireIdsStepUp", bool_type], ["IsAdminUser", bool_type], ["MenuItems", list_type(MenuItem$reflection())], ["RoleItems", RoleItem$reflection()], ["SelectedLanguage", string_type], ["VersionBadgeUrl", option_type(string_type)], ["CountryCode", IsoCountryCode$reflection()], ["LanguageCode", string_type], ["Privileges", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

